import { Box, Typography } from '@mui/material';
import clsx from 'clsx';
import React from 'react';
import ReactMarkdown from 'react-markdown';
import { useStyles } from './styles';
import { MarkdownProps } from './types';

export const Markdown: React.FC<MarkdownProps> = ({ components, ...rest }) => {
  const styles = useStyles();

  return (
    <ReactMarkdown
      components={{
        p: props => <Typography variant="body2" {...props} />,
        ul: ({ className, ...props }) => <Box component="ul" className={clsx(className, styles.ul)} {...props} />,
        li: ({ className, children, ...props }) => (
          <Box component="li" className={className} {...props}>
            <Typography variant="body2" component="span">{children}</Typography>
          </Box>
        ),
        ...components,
      }}
      {...rest}
    />
  );
};
